module.exports = __webpack_public_path__ + "static/media/underground.68a86aee.jpg";